import { Routes } from '@angular/router';
import { providerGuard } from './guards/provider.guard';
import { sadashboardGuard } from './guards/sadashboard.guard';
import { adminGuard } from './guards/admin.guard';
import { ProfileCompletionGuard } from './guards/profile-completion.guard';
import { BlogsComponent } from './pages/blog/blog';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/homepage/homepage').then(m => m.Homepage),
  },
  {
    path: 'category',
    loadComponent: () => import('./pages/category/category').then(m => m.Category),
    canActivate: [ProfileCompletionGuard]
  },
  {
    path: 'category/:province',
    loadComponent: () => import('./pages/category/category').then(m => m.Category),
    canActivate: [ProfileCompletionGuard]
  },
  {
    path: 'category/:id',
    loadComponent: () => import('./pages/category/category').then(m => m.Category),
    canActivate: [ProfileCompletionGuard]
  },
  {
    path: 'category/:province/:id',
    loadComponent: () => import('./pages/category/category').then(m => m.Category),
    canActivate: [ProfileCompletionGuard]
  },
  {
    path: 'browser-maps',
    loadComponent: () => import('./pages/tourist-map/tourist-map').then(m => m.TouristMap),
    canActivate: [ProfileCompletionGuard]
  },
  {
    path: 'provider/:id',
    loadComponent: () => import('./pages/provider/provider').then(m => m.Provider),
    canActivate: [ProfileCompletionGuard]
  },
  // Product details route
  {
    path: 'p/:id',
    loadComponent: () => import('./pages/product/product').then(m => m.Product),
  },
  // Reservation route
  {
    path: 'p/:id/reservar',
    loadComponent: () => import('./pages/reservation/reservation').then(m => m.Reservation),
    canActivate: [ProfileCompletionGuard]
  },
  // Confirmation route
  {
    path: 'confirmation/:id',
    loadComponent: () => import('./pages/confirmation/confirmation').then(m => m.Confirmation),
  },
  // Profile page for tourists
  {
    path: 'profile',
    loadComponent: () => import('./pages/profile/profile').then(m => m.Profile),
  },
  // Dashboard principal (restricted access)
  {
    path: 'sadashboard',
    loadComponent: () => import('./pages/sadashboard/sadashboard').then(m => m.Sadashboard),
    canActivate: [sadashboardGuard],
  },
  // Rotas de Provider (protegidas)
  {
    path: 'sadashboard/provider/posts',
    loadComponent: () => import('./pages/sadashboard/providercomponents/pages/posts/posts').then(m => m.Posts),
    canActivate: [providerGuard]
  },

  {
    path: 'sadashboard/provider/reservations',
    loadComponent: () => import('./pages/sadashboard/providercomponents/pages/reservations/reservations').then(m => m.Reservations),
    canActivate: [providerGuard]
  },
  {
    path: 'sadashboard/provider/calendar',
    loadComponent: () => import('./pages/sadashboard/providercomponents/pages/calendar/calendar').then(m => m.Calendar),
    canActivate: [providerGuard]
  },
  {
    path: 'sadashboard/provider/analytics',
    loadComponent: () => import('./pages/sadashboard/providercomponents/pages/analytics/analytics').then(m => m.Analytics),
    canActivate: [providerGuard]
  },
  {
    path: 'sadashboard/provider/messages',
    loadComponent: () => import('./pages/sadashboard/providercomponents/pages/messages/provider-messages.component').then(m => m.ProviderMessagesPageComponent),
    canActivate: [providerGuard]
  },
  // Rotas de Super Admin
  {
    path: 'sadashboard/admin/maps',
    loadComponent: () => import('./pages/sadashboard/superadmincomponents/pages/maps/maps').then(m => m.Maps), canActivate: [adminGuard],
  },
  {
    path: 'sadashboard/admin/hidden-points',
    loadComponent: () => import('./pages/sadashboard/superadmincomponents/pages/hidden-points/hidden-points').then(m => m.HiddenPoints), canActivate: [adminGuard],
  },
  {
    path: 'booking',
    loadComponent: () => import('./pages/sadashboard/superadmincomponents/pages/bookings/bookings').then(m => m.Bookings),
  },
  {
    path: 'sadashboard/admin/providers',
    loadComponent: () => import('./pages/sadashboard/superadmincomponents/pages/providers/providers').then(m => m.Providers), canActivate: [adminGuard],
  },
  {
    path: 'sadashboard/admin/requests',
    loadComponent: () => import('./pages/sadashboard/superadmincomponents/pages/requests/requests').then(m => m.Requests), canActivate: [adminGuard],
  },
  {
    path: 'sadashboard/admin/analitics',
    loadComponent: () => import('./pages/sadashboard/analitics/analitics').then(m => m.Analitics), canActivate: [adminGuard],
  },
  {
    path: 'sadashboard/admin/content-management',
    loadComponent: () => import('./pages/sadashboard/superadmincomponents/pages/content-management/content-management').then(m => m.ContentManagement), canActivate: [adminGuard],
  },
  {
    path: 'sadashboard/admin/categories',
    loadComponent: () => import('./pages/sadashboard/superadmincomponents/pages/categories/categories').then(m => m.Categories), canActivate: [adminGuard],
  },
  {
    path: 'sadashboard/users',
    loadComponent: () => import('./pages/sadashboard/superadmincomponents/pages/users/users').then(m => m.Users),
  },
  {
    path: 'sadashboard/users/create',
    loadComponent: () => import('./pages/sadashboard/superadmincomponents/pages/users/create-admin/create-admin').then(m => m.CreateAdmin),
  },
  {
    path: 'sadashboard/users/:id',
    loadComponent: () => import('./pages/sadashboard/superadmincomponents/pages/userdetails/userdetails').then(m => m.UserdetailsComponent),
  },
  {
    path: 'sadashboard/wallet-fees',
    loadComponent: () => import('./pages/wallet-fees/wallet-fees').then(m => m.WalletFees),
    canActivate: [sadashboardGuard],
  },
  {
    path: 'companies',
    loadComponent: () => import('./pages/companies/companies').then(m => m.CompaniesComponent),
  },
  {
    path: 'companydetails/:id',
    loadComponent: () => import('./pages/companydetails/companydetails').then(m => m.CompanyDetailsComponent),
  },
  {
    path: 'providerdetails/:id',
    loadComponent: () => import('./pages/providerdetails/providerdetails').then(m => m.ProviderDetailsComponent),
  },
  {
    path: 'providers/edit/:id',
    loadComponent: () => import('./pages/providers/edit-provider/edit-provider').then(m => m.EditProviderComponent),
  },
  {
    path: 'providers/new',
    loadComponent: () => import('./pages/providers/edit-provider/edit-provider').then(m => m.EditProviderComponent),
  },
  {
    path: 'tourists',
    loadComponent: () => import('./pages/tourists/tourists').then(m => m.TouristsComponent),
  },
  {
    path: 'tourists/:id',
    loadComponent: () => import('./pages/touristdetails/touristdetails').then(m => m.TouristDetailsComponent),
  },
  {
    path: 'tourists/edit/:id',
    loadComponent: () => import('./pages/tourists/edit-tourist/edit-tourist').then(m => m.EditTouristComponent),
  },
  {
    path: 'roles',
    loadComponent: () => import('./pages/roles/roles').then(m => m.RolesComponent),
  },
  {
    path: 'roles/create',
    loadComponent: () => import('./pages/create-role/create-role').then(m => m.CreateRole),
  },

  {
    path: 'blog',
    loadComponent: () => import('./pages/blog/blog').then(m => m.BlogsComponent),
    canActivate: [ProfileCompletionGuard]
  },
  {
    path: 'contacto',
    loadComponent: () => import('./pages/contactos/contactos').then(m => m.Contactos),
    canActivate: [ProfileCompletionGuard]
  },
  {
    path: 'politicas-e-privacidade',
    loadComponent: () => import('./pages/privacy-policy/privacy-policy').then(m => m.PrivacyPolicy),
  },

  // Rota para reset password
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/reset-password/reset-password').then(m => m.RedefinirSenha),
  },

  // Rota para callback OAuth2
  {
    path: 'auth/callback',
    loadComponent: () => import('./components/oauth2-callback/oauth2-callback').then(m => m.OAuth2CallbackComponent)
  },

  {
    path: 'sadashboard/provider/posts/newpost',
    loadComponent: () => import('./pages/post/post').then(m => m.PostComponent),
  },

  {
    path: 'sadashboard/provider/posts/editpost/:id',
    loadComponent: () => import('./pages/post/post').then(m => m.PostComponent),
  },

  // Rota para criação de provedor
  {
    path: 'cprovider',
    loadComponent: () => import('./pages/cprovider/cprovider').then(m => m.CproviderComponent),
  },

  // Rota para listagem de reservas do sistema
  {
    path: 'bookings',
    loadComponent: () => import('./pages/sadashboard/superadmincomponents/pages/bookings/bookings').then(m => m.Bookings),
  },

  // Rota para detalhes de uma reserva específica
  {
    path: 'bookings/:id',
    loadComponent: () => import('./pages/sadashboard/superadmincomponents/pages/booking-details/booking-details').then(m => m.BookingDetails),
  },
];
